import React, {Component} from 'react'
import Price from "./Price.jsx"
import { addToCart } from '../../utils/Cart.js'

class ProductTile extends Component {
  constructor(props) {
    super(props)
    const metalOption = props.props.options.find((option) => {
      const optionName = option.name.toLowerCase()
      return ['metal', 'material', 'color'].includes(optionName)
    })
    if(metalOption) {
      metalOption.values = metalOption.values.filter(value => 
        props.props.variants.edges.filter(e => 
          value.includes(e.node.selectedOptions.find(option => option.name == metalOption.name)?.value || '')
        ).length > 0
      )
    }
    
    const availableVariant = props.props.variants.edges.find((edge) => edge.node.availableForSale && !this.checkVariantVisibility(edge))
    const firstVisible = props.props.variants.edges.find((edge) => !this.checkVariantVisibility(edge))
    const firstSale = props.props.variants.edges.find((edge) => edge.node.availableForSale && !this.checkVariantVisibility(edge) && edge.node.compareAtPrice && parseFloat(edge.node.compareAtPrice.amount) > parseFloat(edge.node.price.amount))
    const preselects = typeof props.props.preselect != 'undefined' && props.props.preselect && props.props.preselect != '' ? props.props.preselect.split(',') : []

    let selectedVariant = (typeof availableVariant != 'undefined' && availableVariant) ? availableVariant.node : (firstVisible && props.props.template_suffix && props.props.template_suffix == 'lookbook' ? firstVisible.node : props.props.variants.edges[0].node)
    selectedVariant = location.href.includes('sale-2023') ? ((typeof firstSale != 'undefined' && firstSale) ? firstSale.node : selectedVariant) : ((typeof firstSale != 'undefined' && firstSale && firstSale.node.availableForSale) ? firstSale.node : selectedVariant)
    let preselectVariant = preselects.length > 0 ? props.props.variants.edges.filter((edge) => !this.checkVariantVisibility(edge) && edge.node.selectedOptions[0] && (preselects.includes(edge.node.selectedOptions[0].value)))[0] : null
    
    selectedVariant = preselectVariant ? preselectVariant.node : selectedVariant

    let sortedMetalValues = []
    if(typeof metalOption != 'undefined' && metalOption) {
      sortedMetalValues = metalOption.values.filter((value) => props.props.variants.edges.filter((edge) => edge.node.availableForSale && !this.checkVariantVisibility(edge) && edge.node.selectedOptions[0].value === value).length)
      sortedMetalValues = sortedMetalValues.concat(
        sortedMetalValues = metalOption.values.filter((value) => props.props.variants.edges.filter((edge) => edge.node.availableForSale && !this.checkVariantVisibility(edge) && edge.node.selectedOptions[0].value === value).length == 0)
      )
    }
    this.state = {
      data: props.props,
      selectedVariant: selectedVariant,
      metalOption: metalOption,
      metalSelectedOption: selectedVariant.selectedOptions[0].value,
      secondOption: metalOption ? props.props.options.filter((option) => metalOption.name != option.name && !option.values.includes('Default Title'))[0] : (props.props.options[0].values.includes('Default Title') ? null : props.props.options[0]),
      isPair: props.props.tags.includes('single-pair') ? true : false,
      secondSelected: '',
      multiply: 1,
      availableForSale: props.props.variants.edges.filter((edge) => edge.node.availableForSale && edge.node.selectedOptions[0].value == selectedVariant.selectedOptions[0].value).length > 0,
      sortedMetalValues: sortedMetalValues,
      cartProperties: (typeof props.props.rebuyWidgetId != 'undefined' && props.props.rebuyWidgetId ? {_attribution: 'Rebuy Product', _widget_id: props.props.rebuyWidgetId.toString(), _source: 'Rebuy'} : {}),
      hiddenVariantCount: props.props.variants.edges.filter((edge) => this.checkVariantVisibility(edge)).length,
      lookbook: (props.props.template_suffix && props.props.template_suffix == 'lookbook') || props.props.tags.includes('Lookbook') || props.props.tags.includes('In-studio exclusive'),
    }
    console.log(this.state.data.title, this.state)

    window[`learnqProductItem_${this.getId(this.state.data.id)}`] = (typeof window[`learnqProductItem_${this.getId(this.state.data.id)}`] != 'undefined' ? window[`learnqProductItem_${this.getId(this.state.data.id)}`] :
      {
        'Name': this.state.data.title,
        'ProductID': this.getId(this.state.data.id),
        'Categories': this.state.data.collections.edges.map((edge) => edge.node.title),
        'ImageURL': this.state.data.featuredImage ? this.state.data.featuredImage.url : '',
        'URL': `https://heyrowan.com/products/${this.state.data.handle}`,
        'Brand': this.state.data.vendor,
        'Price': `$${this.state.selectedVariant.price.amount}`,
        'CompareAtPrice': this.state.selectedVariant.compareAtPrice && parseFloat(this.state.selectedVariant.compareAtPrice.amount) > parseFloat(this.state.selectedVariant.price.amount) ? `$${this.state.selectedVariant.price.amount}` : '$0.00',
        'Added to Cart Value': `$${this.state.selectedVariant.price.amount}`
      })

    if(this.state.hiddenVariantCount == this.state.data.variants.edges.length) document.querySelector(`[product-tile="${this.getId(this.state.data.id)}"]`).closest('.grid__item').classList.add('!hidden')
  }

  getId(id, type='Product') {
    return id.replace(`gid://shopify/${type}/`, '')
  }

  updateVariantByMetal(value) {
    const metalVariants = this.state.data.variants.edges.filter((edge) => edge.node.selectedOptions[0].value === value)
    const selectedVariant = (metalVariants.filter((edge) => edge.node.availableForSale).length > 0 ? metalVariants.filter((edge) => edge.node.availableForSale)[0].node : null) || metalVariants[0].node
    this.setState({
      selectedVariant: (metalVariants.filter((edge) => edge.node.availableForSale).length > 0 ? metalVariants.filter((edge) => edge.node.availableForSale)[0].node : null) || metalVariants[0].node,
      metalSelectedOption: selectedVariant.selectedOptions[0].value,
      availableForSale: this.state.data.variants.edges.filter((edge) => edge.node.availableForSale && edge.node.selectedOptions[0].value == selectedVariant.selectedOptions[0].value).length > 0
    })
    if(typeof this.props.updateBundlePrices != 'undefined' && this.props.updateBundlePrices) this.props.updateBundlePrices()
  }

  availability(optionName) {
    return this.state.data.variants.edges.filter((edge) => {
      return edge.node.selectedOptions.filter((option) => option.value == optionName).length > 0 && edge.node.availableForSale
    }).length
  }

  isOptionSelected(optionName) {
    return this.state.selectedVariant.selectedOptions.filter((option) => option.value == optionName).length > 0
  }
  renderMainImage() {
    let mainImg = this.state.selectedVariant.image && this.state.selectedVariant.image.url ? this.state.selectedVariant.image : this.state.data.featuredImage

    if(this.state.selectedVariant.selectedOptions.filter((option) => option.value.includes('Pair')).length > 0 || this.state.secondSelected == 'Pair' ) {
      const imageAlt = `pair:${this.state.selectedVariant.selectedOptions[0].value.toLowerCase().trim()}`
      this.state.data.images.edges.forEach((edge) => {
        const alt = edge.node.altText ? edge.node.altText.toLowerCase() : null
        if (alt && alt == imageAlt) mainImg = edge.node
      })
    }
    if(mainImg) {
      return <img srcSet={`${mainImg.url}&width=165 165w, ${mainImg.url}&width=360 360w, ${mainImg.url}&width=533 533w, ${mainImg.url}&width=720 720w`} 
        src={`${mainImg.url}&width=533`} sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" 
        alt='' 
        loading="lazy" 
        className="motion-reduce" 
        width="600" 
        height="600" />
    }
    return
  }

  renderSecondImage() {
    if (this.state.data.images.length < 2) ''
    let secondImage = this.state.data.images.edges[this.state.data.images.edges.length - 1].node
    let comparedValue = this.state.selectedVariant.selectedOptions[0].value.toLowerCase().trim()
    
    this.state.data.images.edges.every((edge) => {
      const alt = (edge.node.altText || '').toLowerCase().trim()
      if(alt.includes('rollover')) {
        if(!alt.includes('rollover:')) secondImage = edge.node
        return false
      }
      return true
    })

    comparedValue = `rollover:${comparedValue}`
    this.state.data.images.edges.every((edge) => {
      const alt = (edge.node.altText || '').toLowerCase().trim()
      if(alt.includes(comparedValue)) {
        secondImage = edge.node
        return false
      }
      return true
    })
    
    return <img srcSet={`${secondImage.url}&width=165 165w, ${secondImage.url}&width=360 360w, ${secondImage.url}&width=533 533w, ${secondImage.url}&width=720 720w`} src={`${secondImage.url}&width=533`} sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt='' loading="lazy" className="motion-reduce  second-img" width="600" height="600" />
  }

  getVariantByOptions(metalSelectedOption, secondSelectedOption) {
    return this.state.data.variants.edges.filter((edge) => typeof this.state.metalOption != 'undefined' && this.state.metalOption ? edge.node.selectedOptions[0].value === metalSelectedOption && edge.node.selectedOptions[1].value === secondSelectedOption : edge.node.selectedOptions[0].value === secondSelectedOption)[0].node
  }
  updateSelectedVariantBySecondOption(secondOption) {
    if(this.state.isPair) {
      this.setState({
        multiply: secondOption == 'Pair' ? 2 : 1,
        secondSelected: secondOption,
      })
    } else {
      const selectedVariant = this.state.data.variants.edges.filter((edge) => typeof this.state.metalOption != 'undefined' && this.state.metalOption ? edge.node.selectedOptions[0].value === this.state.metalSelectedOption && edge.node.selectedOptions[1].value === secondOption : edge.node.selectedOptions[0].value === secondOption)[0].node
      this.setState({
        selectedVariant: selectedVariant,
        availableForSale: this.state.data.variants.edges.filter((edge) => edge.node.availableForSale && edge.node.selectedOptions[0].value == selectedVariant.selectedOptions[0].value).length > 0
      })
    }
    if(typeof this.props.updateBundlePrices != 'undefined' && this.props.updateBundlePrices) this.props.updateBundlePrices()
  }

  renderSecondOptions() {
    if(this.state.secondOption || this.state.isPair) {
      if(this.state.secondOption) {
        return <ul className={`plp-second-option`} data-pair="true">
          {
            this.state.secondOption.values.map((value, index) => <li key={`product-secondoption-${this.getId(this.state.data.id)}-${index}`}>
              <label onClick={(e) => this.updateSelectedVariantBySecondOption(value)}>
                <input type="radio" name={`product-second-${this.getId(this.state.data.id)}`} value={value} defaultChecked={this.state.selectedVariant.selectedOptions.filter((option) => option.value == value).length > 0 ? true : false} />
                <span className="plp-second-option--mark"></span>
                {value}
                <span data-second-option-price="">
                  <Price price={this.getVariantByOptions(this.state.selectedVariant.selectedOptions[0].value, value).price} 
                    compareAtPrice={this.getVariantByOptions(this.state.selectedVariant.selectedOptions[0].value, value).compareAtPrice}
                    multiply={1}
                    priceRange={this.state.data.priceRange}
                    lookbook={this.state.lookbook} />
                </span>
              </label>
            </li>)
          }
        </ul>
      } else {
        return <ul className={`plp-second-option`} data-pair="true">
          <li>
            <label onClick={(e) => this.updateSelectedVariantBySecondOption('Single')}>
              <input type="radio" name={`product-second-${this.getId(this.state.data.id)}`} value="Single" defaultChecked />
              <span className="plp-second-option--mark"></span>
              Single
              <span data-second-option-price>
                <Price price={this.state.selectedVariant.price} 
                  compareAtPrice={this.state.selectedVariant.compareAtPrice}
                  multiply={1}
                  priceRange={this.state.data.priceRange}
                  lookbook={this.state.lookbook} />
              </span>
            </label>
          </li>
          <li>
            <label onClick={(e) => this.updateSelectedVariantBySecondOption('Pair')}>
              <input type="radio" name={`product-second-${this.getId(this.state.data.id)}`} value="Pair" />
              <span className="plp-second-option--mark"></span>
              Pair
              <span data-second-option-price>
                <Price price={this.state.selectedVariant.price} 
                  compareAtPrice={this.state.selectedVariant.compareAtPrice}
                  multiply={2}
                  priceRange={this.state.data.priceRange}
                  lookbook={this.state.lookbook} />
              </span>
            </label>
          </li>
        </ul>
      }
    } else
      return ''
  }

  renderBadge() {
    let badge = window.collectionBadge
    let badgeHtml = ''
    this.state.data.collectionBadges.every((c_badge) => {
      if(c_badge) {
        badge = c_badge
        return false
      }
      return true
    })
    if(badge) {
      badge = badge.toLowerCase().replace(/ /g, '-').replace(/_/g, '-')
      if(badge === 'new-arrival')
        badgeHtml = `<img src="https://cdn.shopify.com/s/files/1/1871/4993/files/new-arrival.webp?width=200" alt="" loading="lazy">`
      else if(badge === 'bestseller' || badge === 'best-seller')
        badgeHtml = `<img src="https://cdn.shopify.com/s/files/1/1871/4993/files/bestseller.webp?width=200" alt="" loading="lazy">`
      else if(badge === 'giftingfave' || badge === 'gifting-fave')
        badgeHtml = `<img src="https://cdn.shopify.com/s/files/1/1871/4993/files/gifting-fave.webp?width=200" alt="" loading="lazy">`
      else if(badge === 'sale')
        badgeHtml = `<img src="https://cdn.shopify.com/s/files/1/1871/4993/files/sale.png?width=200" alt="" loading="lazy">`
      else
        badgeHtml = `<span>${badge}</span>`
    }
    return location.href.includes('holiday-gift-guide') || location.href.includes('collections/sale-2023') ? '' : <div className="card-message" dangerouslySetInnerHTML={{ __html: badgeHtml }}></div>
  }

  checkVariantVisibility(variant) {
    let hide = variant.node.variantHide && (variant.node.variantHide.value == true || variant.node.variantHide.value == 'true')
    if(typeof variant.node.force != 'undefined' && variant.node.force && variant.node.force != 'null') {
      if(variant.node.force.value == 'Show')
        hide = false
      else if(variant.node.force.value == 'Hide')
        hide = true
    }

    return hide
  }

  variantHidden(optionValue) {
    const variant = this.state.data.variants.edges.filter((edge) => edge.node.selectedOptions.filter((o) => o.value === optionValue).length > 0)[0]
    return (typeof variant != 'undefined' && variant && this.checkVariantVisibility(variant)) ? '!hidden' : ''
  }

  render() {
    return (
      <div className={`card-wrapper ${this.props.updateBundlePrices && !(this.state.metalOption && this.renderSecondOptions() != '') ? '!justify-start' : ''}`} data-state={JSON.stringify({selectedVariant: this.state.selectedVariant, multiply: this.state.multiply, cartProperties: this.state.cartProperties}).replace("'", "’")}>
        <div className="card-image-title full-unstyled-link group relative">
          <a href={`/products/${this.state.data.handle}`} 
            className="absolute z-2 inset-0 !block" 
            aria-label={`Details of ${this.state.data.title}${this.state.metalOption && this.state.selectedVariant ? ' - ' + this.state.selectedVariant.selectedOptions?.filter((option) => option.name == this.state.metalOption.name)[0].value : ''} - $${(this.state.multiply ? parseFloat(this.state.selectedVariant.price.amount) * this.state.multiply : parseFloat(this.state.selectedVariant.price.amount)).toFixed(2)}`}
          >
          </a>
          <div className="card card--product" tabIndex="-1">
            <div className="card__inner">
              <div>
                <div className="media media--transparent media--adapt media--hover-effect"  style={{paddingBottom: '100%'}}>
                  {this.renderMainImage()}
                  {this.renderSecondImage()}
                </div>
              </div>
            </div>
          </div>

          <div className="card-information">
            <div className="card-information__wrapper">
              <span className="card-information__text group-focus:underline">{ this.state.data.title }</span>
              {!(this.state.data.gift_card && this.state.data.variants.edges.length > 1) && 
                <Price price={this.state.selectedVariant.price} compareAtPrice={this.state.selectedVariant.compareAtPrice} multiply={this.state.multiply} priceRange={this.state.data.priceRange} lookbook={this.state.lookbook} />
              }
            </div>
          </div>
          { this.renderBadge() }
        </div>

        <div className="plp-ctas">
          <div className="plp-swatches-reviews ">
            <div className="plp-swatches" role="radiogroup" 
              aria-label={`${this.state.metalOption && this.state.sortedMetalValues.length > 0 ? 'Select a color' : 'Product options'} of ${this.state.data.title}`}
            >
              {this.state.metalOption && 
                this.state.sortedMetalValues.map((value, index) => 
                  index > (this.state.lookbook ? 4 : 2) ?
                  ''
                  :<button data-value={value} className={`plp-swatch-element ${this.variantHidden(value)} color-${value.replace('&', '').replace(/ \/ /g, '-').replace(/ /g, '-').replace(/-+/g, "-").toLowerCase()} ${this.availability(value) ? 'available' : (this.state.lookbook || this.state.data.tags.includes('#available-in-studio') ? '' : 'soldout')} ${this.isOptionSelected(value) ? 'selected' : ''}`} key={`plp-swatch-${this.getId(this.state.data.id)}-${index}`}
                    onClick={(e) => this.updateVariantByMetal(value)}
                    data-swatch-variant={!this.state.lookbook && this.state.selectedVariant.availableForSale ? this.getId(this.state.selectedVariant.id, 'ProductVariant') : null}
                    aria-label={`${this.state.data.title}: ${value}`}
                    aria-checked={this.isOptionSelected(value)}
                    role="radio"
                  />
                )
              }
              {
                this.state.metalOption && (this.state.sortedMetalValues.length - this.state.hiddenVariantCount < 4) && <div className="plp-selected-swatch">{ this.state.selectedVariant.selectedOptions.filter((option) => option.name == this.state.metalOption.name)[0].value }</div>
              }
              {
                this.state.metalOption && (this.state.sortedMetalValues.length - this.state.hiddenVariantCount > 3) && 
                <a href={`/products/${this.state.data.handle}`}>
                  +{this.state.sortedMetalValues.length - this.state.hiddenVariantCount - 3} more<span className='visually-hidden'>&nbsp;colors for {this.state.data.title}</span>
                </a>
              }
              {
                (!this.state.metalOption || !this.state.sortedMetalValues?.length) && <span className='selected visually-hidden !hidden' data-swatch-variant={this.getId(this.state.selectedVariant.id, 'ProductVariant')} />
              }
            </div>
          </div>
          <div className={`plp-form`}>
            {
              this.state.lookbook ?
              <a className={`plp-cta-button plp-cta-button--submit button button--outline`} 
                href={ this.state.data.tags.includes('#Available-in-studio') ? `/products/${this.state.data.handle}` : `${this.state.data.plpInStoreUrl || ('/products/' + this.state.data.handle)}` }
              >
                { this.state.data.tags.includes('#Available-in-studio') ? 'Available in-studio' : 'In-studio exclusive' }
                <span className='visually-hidden'>
                  {`The ${this.state.data.title} is only available in studios.`}
                </span>
              </a>
              :<>
                {
                  this.props.updateBundlePrices ?
                  (
                    this.state.metalOption && this.renderSecondOptions() != '' ? 
                    <button className={`plp-cta-button plp-cta-button--submit button button--outline ${(this.state.availableForSale && this.renderSecondOptions() != '') || (this.renderSecondOptions() == '' && this.state.data.pairingOption.length > 0) ? '' : 'invisible'} ${this.renderSecondOptions() == '' && this.state.data.pairingOption.length > 0 ? 'hover:bg-transparent hover:text-black' : ''}`}
                    >
                      {this.renderSecondOptions() != '' && 'Select Single or Pair'}
                      {/* {this.renderSecondOptions() == '' && this.state.data.pairingOption.length > 0 && this.state.data.pairingOption[0]} */}
                    </button> : 
                    null
                  )
                  :
                  <button className={`plp-cta-button plp-cta-button--submit button button--outline ${this.state.availableForSale ? '' : 'hide'}`} onClick={(e) => addToCart({ id: this.getId(this.state.selectedVariant.id, 'ProductVariant'), quantity: this.state.multiply, properties: Object.assign(this.state.cartProperties, this.state.selectedVariant.compareAtPrice && parseFloat(this.state.selectedVariant.compareAtPrice.amount) > parseFloat(this.state.selectedVariant.price.amount) ? {'Compare Price': `$${this.state.selectedVariant.compareAtPrice.amount}`} : {}), sellingPlan: false, cartOpen: true, buttonElement: e.target }) }>
                    {
                      this.state.data.tags.includes('presale') ? 'Preorder' : 'Add to cart'
                    }
                  </button>
                }
                
                { this.renderSecondOptions() }
              </>  
            }
            
          </div>
          <a className={
            `plp-cta-button plp-cta-button--notify button button--outline ${this.state.availableForSale || this.state.lookbook ? 'hide' : (this.state.data.tags.includes('#available-in-studio') ? '' : 'pointer-events-none opacity-50')}`
          } 
            href={`/products/${this.state.data.handle}`}
          >
            <span className='visually-hidden'>
              {this.state.data.title} is 
            </span>
            { this.state.data.tags.includes('#available-in-studio') ? 'Available in-studio' : 'Sold out' }
          </a>
        </div>
        
        {
          location.href.includes('holiday-gift-guide') && this.state.data.tags.includes('top-pick') && <img className="hidden lg:inline-block absolute top-12 right-12" src={`${window.globalIcons['icon-heart']}`} alt={`Top Pick - ${this.state.data.title}`} style={{width: '10.6rem'}} loading="lazy" />
        }
      </div>
    )
  }
}

export default ProductTile